import React, { memo } from "react";
import { SetterOrUpdater } from "recoil";
import Flex from "../../ui/Flex/Flex";
import "./style.scss";

type NavLink = {
  link: string;
  index: number;
  id: string;
};

type NavbarLinksProps = {
  links: NavLink[];
  activeLinkIndex: number;
  setActiveLink: SetterOrUpdater<NavLink>;
};
const NavbarLinks = ({
  links,
  activeLinkIndex,
  setActiveLink,
}: NavbarLinksProps): JSX.Element => {
  const classNames = require("classnames");

  return (
    <>
      <div id="navbar-links">
        <Flex gap={9}>
          {links.map((link: NavLink) => {
            const linkClasses = classNames("navbar-link", {
              active: activeLinkIndex === link.index,
            });

            return (
              <span
                key={link.index}
                onClick={() => {
                  setActiveLink(link);
                }}
                className={linkClasses}
              >
                {link.link}
              </span>
            );
          })}
        </Flex>
      </div>
    </>
  );
};

export default memo(
  NavbarLinks,
  (prevState, nextState) =>
    prevState.activeLinkIndex === nextState.activeLinkIndex
);
